import { Button } from "@adafia/ui";
import { Plus } from "lucide-react";
import type React from "react";

interface SectionHeaderProps {
	title: string;
	icon: React.ElementType;
	onAdd?: () => void;
}

export const SectionHeader = ({
	title,
	icon: Icon,
	onAdd,
}: SectionHeaderProps) => (
	<div className="section-header-edit">
		<div className="section-title-wrapper">
			<Icon size={18} />
			<h3>{title}</h3>
		</div>
		{onAdd && (
			<Button
				type="button"
				onClick={onAdd}
				className="icon-btn-add"
				variant="secondary"
				title="add"
			>
				<Plus size={18} />
			</Button>
		)}
	</div>
);
